import React from 'react'

let NT7_RecommendedLogo = require('../images/partners/NT7_RecommendedLogo.png');
let kinetick_partner_logo = require('../images/partners/kinetick_partner_logo.png');
let IQFeed = require('../images/partners/IQFeed.png');
let TrueData = require('../images/partners/TrueData.png');
let Profit4traders = require('../images/partners/Profit4traders.jpg');
let rps = require('../images/partners/rps.vinod.logo.png');
let OrbitalLogo = require('../images/partners/OrbitalLogo400x173.png');
let cAlgo = require('../images/partners/cAlgo_logo.png');
let bluecollartrader = require('../images/partners/bluecollartrader_small.png');
let futuresfx = require('../images/partners/futuresfx_ca_logo_small.jpg');
let iTradePod = require('../images/partners/iTradePod_Logo.jpg');

const ResourcesPage = () => (
    <div>
        <section>
            <div className="container">
                <h2>NinjaTrader</h2>
                <br/>
                <img src={NT7_RecommendedLogo} alt="" width="528" height="76"/>
                <p>NinjaTrader® is our #1 recommended trading platform preferred by traders worldwide including our
                    clients.</p>
                <p><b><a href="http://ninjatrader.com/LP/VendorDemo/">Download NinjaTrader</a> & receive immediate
                    FREE access to:</b></p>
                <ul>
                    <li>Real-time futures data</li>
                    <li>Unlimited real-time forex data</li>
                    <li>Advanced charting</li>
                    <li>Trade simulator</li>
                    <li>Strategy development and backtesting</li>
                    <li>Connect to NinjaTrader Brokerage, Interactive Brokers, TD Ameritrade & more…</li>
                </ul>
                <h3><a href="http://ninjatrader.com/LP/VendorDemo/">Get Started for Free</a></h3>
                <p>NinjaTrader’s award-winning <a href="http://ninjatrader.com/GetStarted">trading software</a> is
                    consistently voted an industry leader by the trading community. Featuring 1000s of Apps &
                    Add-Ons for unlimited customization, NinjaTrader is used by over 40,000 traders for advanced
                    market analysis, professional charting and fast order execution.</p>
                <p>For new traders, start preparing for the live markets with a free <a
                    href="http://ninjatrader.com/FreeLiveData">trading simulator</a> featuring real-time market
                    data.</p>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>Kinetick</h2>
                <br/>
                <img src={kinetick_partner_logo} alt="" width="393" height="104"/>
                <p>Kinetick® delivers reliable, fast and cost-effective <a href="http://kinetick.com/">market
                    data</a> to help level the playing field for active traders. Take advantage of unfiltered, real
                    time quotes for stocks, futures and forex that exceed the expectations of the world’s most
                    demanding traders, like us!</p>
                <p>Get started with FREE end-of-day <a href="http://kinetick.com/">historical market data</a>
                    directly through the NinjaTrader platform and learn how you can significantly reduce CME Group
                    Globex exchange fees on real-time market data with Kinetick.</p>
                <p><a href="http://kinetick.com/NinjaTrader" title="Kinetick">Get Started with Free EOD Data</a></p>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>IQFeed</h2>
                <br/>
                <img src={IQFeed} alt="" width="120" height="90"/>
                <p>Professional Data Feed – Futures, Stocks, Forex and Options Data!
                    <ul>
                        <li>Unfiltered Data – True Tick-by-Tick, Every Trade and Every Quote!</li>
                        <li>Deep Historical Data – 180 days of tick (Pre and Post), 10+ Years of 1 minute data on
                            eMini’s, 15+ years on daily, weekly and monthly!
                        </li>
                        <li>Millisecond Precision Time Stamps - More granularity for backtesting, algos and
                            analytics!
                        </li>
                        <li>700+ Market/Breath Indicators – TICK, TRIN, PCRATIO and much more!</li>
                        <li>Watch up to 1800 symbols simultaneously!</li>
                        <li>Connect to UNLIMITED supporting analytical applications at the same time/same pc without
                            needing another user license!
                        </li>
                        <li>Streaming News!</li>
                        <li>Around the clock customer support – 24/6 via chat/email and phone during normal trading
                            hours
                        </li>
                        <li>Redundant Data Centers – An entire data center can go down and you will still continue
                            getting your data feed!
                        </li>
                        <li>CME Globex Non-Pro Fee Exchange Fee Discounts Available for Qualified Traders!</li>
                    </ul>
                    Please contact our rep “James To” directly at <a href="mailto:james.to@dtn.com">james.to@dtn.com</a>
                    or call 402.255.8432 and mention “Final Financial Algorithms” for your SPECIAL DISCOUNTS
                    (NOT available online) and any help.
                </p>
                <ul className="list-links list-links--primary">
                    <li><a href="https://www.iqfeed.net/jamesto/index.cfm?displayaction=start"
                           title="IQFeed">IQFeed</a></li>
                </ul>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>TrueData™</h2>
                <br/>
                <img src={TrueData} alt="" width="400" height="239"/>
                <p><a href="http://truedata.in/" title="TrueData™">TrueData™ Financial Information Pvt Ltd</a> ,
                    provides real-time market data and an increasing number of decision support & trading tools for
                    active traders and financial institutions in India.
                    <ul>
                        <li>Connects to an Increasing number of Markets</li>
                        <li>Very Low latency feeds via Direct Exchange Connectivity</li>
                        <li>Use the Same Login id on Multiple Machines (One at a Time)</li>
                        <li>Run Multiple TA applications at the same time, including Ninja Trader, Multicharts,
                            Amibroker, Metastock, excel etc.
                        </li>
                        <li>Work With All Time Frames Including Tick</li>
                        <li>History backfill available for Tick, 1, 5, 15, 60 min, EOD</li>
                        <li>Automated trading integration with various brokers</li>
                        <li>Unmatched customer support</li>
                    </ul>
                    <ul>
                        <li>Contact Email: support@truedata.in</li>
                        <li>Call: +91-7304-22-44-66</li>
                    </ul>
                    <ul className="list-links list-links--primary">
                        <li><a href="http://truedata.in/" title="IQFeed">TrueData™</a></li>
                    </ul>

                </p>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>Profit4traders</h2>
                <br/>
                <img src={Profit4traders} alt="" width="296" height="200"/>
                <br/>
                <a href="http://www.profit4traders.com/" title="Profit4traders">Profit4traders</a> invite all
                traders connect to
                NinjaTraders social trading network:
                <ul>
                    <li>Possibility open own service for sell trading signals to subscribers around a world in a few
                        clicks.
                    </li>
                    <li>Participation in monthly trading championship will show your trading performance to
                        customers.
                    </li>
                    <li>No need change your broker.</li>
                    <li>Own chat support for subscribers will bring your service on new level.</li>
                    <li>Export your trades in Excel, will help analyze your trading.</li>
                    <li>Unlimited subscription income from subscribers your may get on your pay pal.</li>
                    <li>It is a FREE</li>
                    <li>No need change your broker.</li>
                    <li>Own blog for customers it's possible in a few clicks.</li>
                    <li>A lot more great features a coming: cross trading platform transferring trading signals
                        between Metatrader, NInjatrader, Tradestation ...
                    </li>
                </ul>
                <ul className="list-links list-links--primary">
                    <li><a href="http://www.profit4traders.com/" title="Profit4traders">Profit4traders</a></li>
                </ul>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>RPS.VINOD</h2>
                <br/>
                <img src={rps} alt="" width="450" height="66"/>
                <p><a href="http://www.rpsvinod.com" title="RPS.VINOD">RPS.VINOD</a> , Authorised NinjaTrader
                    Ecosystem Partner in India.

                    Certified Commodity Professional of Multi Commodity Exchange of India Limited (MCX)

                    Prop Trading Firm Funded Account Consultant to trade on US Future Market.

                    Professional mentoring for Indian Future Market (NSE, F&O and MCX)
                    <ul>
                        <li>Contact Email: rpsvinod1@gmail.com</li>
                        <li>Call: 91-72990-36936</li>
                    </ul>
                    <ul className="list-links list-links--primary">
                        <li><a href="http://www.rpsvinod.com" title="RPS.VINOD">RPS.VINOD</a></li>
                    </ul>
                </p>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>OrbitalComputers</h2>
                <br/>
                <img src={OrbitalLogo} alt="" width="400" height="173"/>
                <p><a href="http://www.orbitalcomputers.com/" title="Orbital Computers">Orbital Computers</a> offers
                    custom stock trading computers for serious day-traders at industry low prices. Our computers are
                    specifically designed to maximize reliability, system stability, and performance, while
                    providing remarkable multi-monitor expandability. All of our trading computers are hand built in
                    the USA and every order ships FREE. We custom configure every trading computer to your unique
                    needs, making certain you get the absolute best computer at the lowest price possible. Contact
                    us at <a href="http://www.orbitalcomputers.com/" title="Orbital Computers">Orbital Computers</a>
                    today!</p>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>cAlgo</h2>
                <br/>
                <img src={cAlgo} alt="" width="400" height="119"/>
                <p><a href="http://www.spotware.com/products/client-side-applications/calgo">cAlgo</a> is a powerful
                    algorithmic trading platform that is part of the cTrader platform suite. Developed by Spotware
                    Systems, an award-winning financial technology provider for STP and direct-access trading, cAlgo
                    is part of a range of the fastest growing trading platforms in FX and other financial markets.
                    cAlgo can be used to build and test custom trading robots and indicators of any degree of
                    complexity.</p>
                <p>Visit <a href="http://ctdn.com/">cTDN.com</a> to join the cAlgo developers community, or go to <a
                    href="http://www.spotware.com/">www.spotware.com</a> to read more about our platforms.</p>
                <ul className="list-links list-links--primary">
                    <li><a href="http://www.spotware.com/" title="Download">Download cTrader</a></li>
                    <li><a href="http://www.spotware.com/" title="Download">Download cAlgo</a></li>
                </ul>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>The Blue Collar Trader</h2>
                <br/>
                <img src={bluecollartrader} alt="" width="300" height="172"/>
                <p>Not only does The Blue Collar Trader provide resources for quality day trading education, but
                    resources for brokers, trading platforms, webinar events, Live Trading Rooms, video Recaps,
                    technology, jobs and much more. Subscribe to our blog today and receive new market updates,
                    discounts, and education from a network of quality companies and educators.
                    Visit us at <a href="http://www.thebluecollartrader.com/">www.thebluecollartrader.com</a></p>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>FuturesFx</h2>
                <br/>
                <img src={futuresfx} alt="" width="300" height="49"/>
                <p>3 room 3 traders 3 Time zones<br/>
                    Use non lagging indicators<br/>
                    Learn to trade with 1 to 3 ticks smart stops<br/>
                    Spot your end off buying and selling<br/>
                    Watch the short videos below and familiarise yourself with our strategy</p>
                <ul className="list-links list-links--primary">
                    <li><a href="http://www.screencast.com/t/oG5QOEnC6xmS" title="Video">Video 1, 2, 3, 4 and 5</a>
                    </li>
                    <li><a href="http://www.futuresfx.ca/" title="futuresfx">www.FuturesFx.Ca</a></li>
                </ul>
            </div>
        </section>

        <section>
            <div className="container">
                <h2>iTradePod</h2>
                <br/>
                <img src={iTradePod} alt="" width="380" height="95"/>
                <p>iTradePod mentors traders to achieve financial independence. Since inception, iTradePod has been
                    dedicated to achieving trader excellence by providing invaluable <a
                        href="http://www.itradepod.com/Clients">market data</a>,
                    <a href="http://www.itradepod.com/education">education,</a> training and trading experience for
                    traders by traders. The iTradePod approach allows traders to learn and apply the time tested
                    concepts of Auction Market Theory, Market Profile® and Order Flow; one of the few reliable
                    methods that consistently and objectively describe the state of the market across all time
                    frames.</p>
                <p>These <a href="http://www.itradepod.com/Education/ValueTradingBasics">Value Trading</a>
                    principles allow traders to identify powerful market moves and locate high probability trade
                    setups. Serious traders are encouraged to join their interactive Live Call
                    <a href="http://www.itradepod.com/Services/TradingRoom">Trading Room</a> where clients can ask
                    questions to the Head Trader whilst he analyses the chart, divulges trading setups and
                    executions to the audible backdrop of the energetic CME S&P 500 Pit Trading Floor activity via
                    their
                    <a href="http://www.itradepod.com/Products/Squawk">Live Squawk Box feed.</a></p>
                <p>For further details on the iTradePod approach, please visit <a href="http://www.itradepod.com/">www.itradepod.com.</a>
                </p>
            </div>
        </section>
    </div>
);

export default ResourcesPage;


// WEBPACK FOOTER //
// ./src/pages/resources.js